import ThankYouPage from './ThankYouPage'

const ImpactWindowsNewQuoteThankYou = () => (
    <ThankYouPage returnPath="/impact-windows" contentCategory="Impact Windows" />
)

export default ImpactWindowsNewQuoteThankYou
